import { filter } from 'lodash';
import { updateProjectAnalysisLayerInStore } from './layersDispatchers';
import { setProjectAnalysisLayers } from './layersActions';
import { updateProjectAnalysisGroupParticipationsInStore } from './participationsActions';

import {
  SET_ANALYSIS_PROJECT_ID_LISTEN_SOCKET,
  RESET_ANALYSIS_SECTION,
  SET_ANALYSIS_MODES
} from './consts';

export const setAnalysisModes = analysisModes => {
  return {
    type: SET_ANALYSIS_MODES,
    analysisModes
  };
};

export const resetProjectAnalysis = () => {
  return {
    type: RESET_ANALYSIS_SECTION
  };
};

export const setProjectContextListenerId = listeningLayers => {
  return {
    type: SET_ANALYSIS_PROJECT_ID_LISTEN_SOCKET,
    listeningLayers
  };
};

export const removeGroupParticipantFromLayers = groupParticipationId => {
  return (dispatch, getState) => {
    const newLayers = getState().analysis.single.layers.map(layer => {
      layer.layer_group_participations_associations = filter(
        layer.layer_group_participations_associations,
        g => {
          return g.group_participations_id !== groupParticipationId;
        }
      );
      return layer;
    });

    dispatch(setProjectAnalysisLayers(newLayers));
  };
};

export const setProjectContextListener = () => {
  return (dispatch, getState, { apiClient, feathersClient }) => {
    let projectId = null;

    if (getState().projects.single.active) {
      projectId = getState().projects.single.active.id;

      // Listen for layers
      feathersClient.io.on(`projects/${projectId}/layers`, payload => {
        dispatch(updateProjectAnalysisLayerInStore(payload));
      });

      // Listen for groupParticipations
      feathersClient.io.on(`projects/${projectId}/groupParticipations`, payload => {
        dispatch(updateProjectAnalysisGroupParticipationsInStore(payload));
        if (payload.operation === 'remove') {
          dispatch(removeGroupParticipantFromLayers(payload.data.id));
        }
      });

      dispatch(setProjectContextListenerId(projectId));
    }
  };
};

export const removeActiveListeners = () => {
  return (dispatch, getState, { apiClient, feathersClient }) => {
    const projectId = getState().analysis.single.listeningLayers;

    if (projectId !== false) {
      feathersClient.io.off(`projects/${projectId}/layers`);
      dispatch(setProjectContextListenerId(false));
    }
  };
};



// WEBPACK FOOTER //
// ./src/scenes/analysis/data/analysis/actions.js